<template>
  <div class="payment-options-container">
    <checkout-payment-headline :title="$t('checkout.infoAndPayment.paymentOptions')"/>
    <div class="cards-container">
      <div v-for="card in paymentOptionsData"
           :key="card.title"
           @click="toggleCard(card)"
           class="card"
           :class="[{ selected: card.key === chosenOption }, { disabled: disablePaymentMethods(card) }]">
        <img :src="card.image" alt=""/>
        <span>{{ card.title }}</span>
      </div>
    </div>
    <div v-if="!$props.paymentAvailable || $props.isCardDisabled" class="payment-unavailable">
      {{ $t('checkout.infoAndPayment.paymentByCardUnavailable') }}
      <v-popover trigger="hover"
                 placement="top-center">
        <span class="icon-info">
          <span class="path1"/>
          <span class="path2"/>
          <span class="path3"/>
        </span>
        <template slot="popover">
          <div class="popover-payment-unavailable">
            <span>{{ $t('checkout.infoAndPayment.unavailableIfTitle') }}</span>
            <span>{{ $t('checkout.infoAndPayment.unavailableIfPos') }}</span>
            <span>{{ $t('checkout.infoAndPayment.unavailableIfBuyOut') }}</span>
            <span>{{ $t('checkout.infoAndPayment.unavailableIfCable') }}</span>
          </div>
        </template>
      </v-popover>
    </div>
  </div>
</template>

<script>
import CheckoutPaymentHeadline from './checkout-payment-headline'

export default {
  name: 'payment-options',
  components: { CheckoutPaymentHeadline },
  props: {
    isCardDisabled: {
      type: Boolean,
      default: true
    },
    paymentAvailable: Boolean
  },
  data () {
    return {
      chosenOption: '',
      paymentOptionsData: [
        {
          image: '/assets/images/pouzecem.png',
          title: this.$i18n.t('checkout.infoAndPayment.personalPayment'),
          key: 'ON_COLLECTION'
        },
        {
          image: '/assets/images/platna-kartica.png',
          title: this.$i18n.t('checkout.infoAndPayment.cardPayment'),
          key: 'BY_CARD'
        }
      ]
    }
  },
  mounted () {
    this.$emit('payment-option', this.chosenOption)
  },
  methods: {
    toggleCard (option) {
      if (this.disablePaymentMethods(option)) return
      this.chosenOption = option.key
      this.$emit('payment-option', this.chosenOption)
    },
    disablePaymentMethods (card) {
      return !this.$props.paymentAvailable || (this.$props.isCardDisabled && card.key === 'BY_CARD')
    }
  },
  watch: {
    paymentAvailable: {
      immediate: true,
      handler () {
        this.chosenOption = this.$props.paymentAvailable ? 'ON_COLLECTION' : ''
        this.$emit('payment-option', this.chosenOption)
      }
    },
    isCardDisabled (newVal) {
      if (newVal && this.chosenOption === 'BY_CARD') {
        this.chosenOption = 'ON_COLLECTION'
      }
    }
  }
}

</script>

<style scoped lang="scss">

.payment-options-container {
  display: flex;
  flex-direction: column;

  .cards-container {
    display: flex;
    flex-direction: column;
    @media (map_get($breakpoints, sm)) {
      flex-direction: row;
    }

    .card {
      height: 150px;
      width: 100%;
      background-color: $white;
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &:not(.disabled) {
        cursor: pointer;
      }

      @media (map_get($breakpoints, sm)) {
        width: 210px;
        margin-right: 20px;
      }
      @media (map_get($breakpoints, lg)) {
        &:hover {
          cursor: pointer;
        }
      }

      span {
        color: $text-grey;
        font-size: 16px;
        line-height: 1.5;
        font-weight: 600;
      }
    }

    .selected {
      border: double 3px transparent;
      background-image: linear-gradient(white, white), radial-gradient(circle at top left, $dark-red, $warning);
      background-origin: border-box;
      background-clip: content-box, border-box;

      span {
        color: $black;
      }
    }

    img {
      width: 80px;
      height: 50px;
      margin-bottom: 15px;
    }
  }
}

.payment-unavailable {
  display: flex;
  align-items: center;

  .v-popover {
    margin-left: 1rem;
  }
}

.popover-payment-unavailable {
  text-align: left;
  span {
    display: block;
    font-size: 1.4rem;

    &:first-child {
      font-weight: 600;
    }
  }
}
</style>
